import { Pipe, PipeTransform } from '@angular/core';
import { CashSessionStatus } from '../cash-session-status';
import type { TreasuryStatusTone } from '../../../../data/src/lib/entities/treasury.model';

const TONES: Record<CashSessionStatus, TreasuryStatusTone> = {
  [CashSessionStatus.Open]: 'positive',
  [CashSessionStatus.Closing]: 'warning',
  [CashSessionStatus.PendingReview]: 'warning',
  [CashSessionStatus.Closed]: 'neutral',
};

@Pipe({ name: 'cashSessionStatusTone', standalone: true, pure: true })
export class CashSessionStatusTonePipe implements PipeTransform {
  transform(value: CashSessionStatus): TreasuryStatusTone {
    return TONES[value];
  }
}
